import React from 'react'

const AlignLeftIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M15 15H3V17H15V15ZM15 7H3V9H15V9ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z"
            fill={color}
        />
    </svg>
)

export default AlignLeftIcon
